import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as urlValues from '../oldReportsUrls'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import { appendToUrl, diffInMonths, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import {
    branchStockReportViewData,
    reportOption,
    GoodBalReprtPayType,
    reportGroupByOption,
    PDFHeaderColumnsWithoughtPayType,
    PDFHeaderColumnsWithPayType,
    PDFHeaderColumnsWithPayTypeFormattedLRNO,
    PDFHeaderColumnsWithPayTypeForBoth,
    PDFHeaderColumnsWithoughtPayTypeFormattedLRNO,
    PDFHeaderColumnsWithoughtPayTypeForBoth,
} from './constants'
import { updateAlertError } from '../../../../store/common/common_action'
import {
    getCargoSettingFilterData,
    getGoodsBalanceFilterData,
} from '../../../../store/reports/reports_action'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import { useSetAtom } from 'jotai'
import { urls } from '../../../common/constants'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../../common/api'

const BranchStockReportNew = () => {
    const state = useSelector((state) => state)
    const { common, reports } = state
    const { loginData, roleRights, companySettings } = common
    const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
    const UseToPayAsCOD = companySettings?.[0]?.UseToPayAsCOD
    const { branchStockFilterData } = reports
    const dispatch = useDispatch()
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [paymentType, setPaymentType] = useState(GoodBalReprtPayType?.[0])
    const [reportView, setReportView] = useState(branchStockReportViewData?.[0])
    const [reportOptions, setReportOptions] = useState(reportOption?.[0])
    const [reportGroupByOptions, setReportGroupByOptions] = useState(reportGroupByOption?.[0])
    const [disableBtn, setDisableBtn] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)

    // --new states--
    const [sourceCity, setSourceCity] = useState('')
    const [sourceCityData, setSourceCityData] = useState([])

    const [sourceBranch, setSourceBranch] = useState('')
    const [sourceBranchData, setSourceBranchData] = useState([])

    const [sourceBranchUser, setSourceBranchUser] = useState('')

    const [destinationCity, setDestinationCity] = useState('')
    const [destinationCityData, setDestinationCityData] = useState([])

    const [destinationBranch, setSelDestinationBranch] = useState('')
    const [destinationBranchdata, setSelDestinationBranchdata] = useState([])

    const reportName = 'Branch Stock'
    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Date', textAlign: 'left' },
        { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
        { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
        { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
        { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
        { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
        { field: 'reportView', header: 'Report View', textAlign: 'left' },
        { field: 'reportOptions', header: 'Report Options', textAlign: 'left' },
        { field: 'reportGroupBy', header: 'Report Group By', textAlign: 'left' },
    ]

    const criteriaData = {
        fromDate: moment(fromDate).format('DD-MM-YYYY') || '',
        toDate: moment(toDate).format('DD-MM-YYYY') || '',
        sourceCity: sourceCity?.City || '',
        sourceBranch: sourceBranch?.Branch || '',
        destinationCity: destinationCity?.DestinationCity || '',
        destinationBranch: destinationBranch?.DestinationBranch || '',
        paymentType: paymentType?.name || '',
        reportView: reportView?.view || '',
        reportOptions: reportOptions?.Option || '',
        reportGroupBy: reportGroupByOptions?.Option || '',
        dataType: 'entry',
    }
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)

    const filterData = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
        } else {
            const obj = {
                CompanyID: loginData?.intCompanyID,
                BranchID: loginData?.intBranchID,
                FromDate: moment(fromDate).format('YYYY-MM-DD'),
                ToDate: moment(toDate).format('YYYY-MM-DD'),
                UserID: loginData?.intUserID,
            }
            dispatch(getGoodsBalanceFilterData(obj))
        }
    }

    const reset = () => {
        setFromDate(moment(new Date()))
        setToDate(moment(new Date()))
        setSourceCity(' ')
        setSourceBranch(' ')
        setSourceBranchUser(' ')
        setDestinationCity(' ')
        setSelDestinationBranch(' ')
        setPaymentType([paymentModesWithAll?.[0]])
        setReportView(branchStockReportViewData?.[-1])
    }

    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const obj = {
                intCompanyID: loginData?.intCompanyID,
                intBranchID: loginData?.intBranchID,
                intUserID: loginData?.intUserID,
            }
            getCargoSettingFilterData(obj)
        }
    }, [loginData])
    useEffect(() => {
        if (!isEmpty(roleRights) && !isEmpty(loginData)) {
            setDisableBtn(
                !(
                    roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
                    roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
                    loginData?.IsBranchAdmin ||
                    loginData?.IsMTPLAdmin ||
                    loginData?.IsAdmin
                )
            )
            setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
        }
    }, [roleRights, loginData])
    const getFilteredData = (branchStockTableData) => {
        if (reportGroupByOptions?.Option === 'With Payment Type') {
            if (branchStockTableData?.Data?.Table1?.length > 0) {
                let data = branchStockTableData?.Data?.Table1
                const filtData = data.map((item) => ({
                    ...item,
                    dataType: 'entry',
                    Qty: `${item.TotalQuantity} ${item.ItemDetails === null ? '' : item.ItemDetails}`,
                }))
                return filtData
            }
        } else {
            if (branchStockTableData?.Data?.Table?.length > 0) {
                let data = branchStockTableData?.Data?.Table
                const filtData = data.map((item, index) => ({
                    ...item,
                    dataType: 'entry',
                    Sr: index + 1,
                    Qty: `${item.TotalQuantity} ${item.ItemDetails === null ? '' : item.ItemDetails}`,
                }))
                return filtData
            }
        }
        return []
    }
    const groupBy = (array, key) => {
        return array.reduce((result, currentValue) => {
            ; (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue)
            return result
        }, {})
    }
    const groupTableData = (tablesData) => {
        const filterData = tablesData.filter((item) => item.TYPE === reportOptions?.optionType)
        const freightTotal = filterData.reduce((a, b) => Number(a) + Number(b.TotalFreight), 0)
        const cartageTotal = filterData.reduce((a, b) => Number(a) + Number(b.Cartage), 0)
        const hamaliTotal = filterData.reduce((a, b) => Number(a) + Number(b.Hamali), 0)
        const netAmountTotal = filterData.reduce((a, b) => Number(a) + Number(b.TotalNet), 0)
        const totalRow = {
            dataType: 'total',
            PaymentType: 'Total:',
            Sr: '',
            LRNO: '',
            BookingDate: '',
            DestBranch: '',
            Sender: '',
            RecName: '',
            Qty: ' ',
            ItemDetails: '',
            TotalFreight: freightTotal,
            Cartage: cartageTotal,
            Hamali: hamaliTotal,
            TotalNet: netAmountTotal,
            colSpan: { Sr: 8 },
            align: { Sr: 'right' }
        }
        const tableData = [...filterData, totalRow]
        const groupedData = groupBy(filterData, 'PaymentType')

        const groupData = []

        Object.entries(groupedData).forEach(([PaymentType, items]) => {
            // Calculate totals for each group
            const freightTotal = items.reduce((a, b) => Number(a) + Number(b.TotalFreight), 0)
            const cartageTotal = items.reduce((a, b) => Number(a) + Number(b.Cartage), 0)
            const hamaliTotal = items.reduce((a, b) => Number(a) + Number(b.Hamali), 0)
            const netAmountTotal = items.reduce((a, b) => Number(a) + Number(b.TotalNet), 0)

            // Push group title (optional)
            // groupData.push({ isGroupHeader: true, type });
            groupData.push({
                dataType: 'subHeader',
                Sr: `${PaymentType} : ${reportOptions?.Option}`,
                colSpan: { Sr: 11 },
                align: { Sr: 'left' },
            })

            // Push group items
            groupData.push(...items)

            // Push total row for group
            groupData.push({
                dataType: 'total',
                PaymentType: 'Total:',
                Sr: '',
                LRNO: '',
                BookingDate: '',
                DestBranch: '',
                Sender: '',
                RecName: '',
                Qty: ' ',
                ItemDetails: '',
                TotalFreight: freightTotal,
                Cartage: cartageTotal,
                Hamali: hamaliTotal,
                TotalNet: netAmountTotal,
                colSpan: { Sr: 8 },
                align: { Sr: 'right' }
            })
        })
        let serialNumber = 1 // Initialize serial number counter

        const finalTableData = groupData.map((row) => {
            if (row.dataType !== 'subHeader' && row.dataType !== 'total') {
                return { ...row, Sr: serialNumber++ } // Assign Sr and increment counter
            }
            return row // Keep other rows unchanged
        })
        if (reportGroupByOptions?.Option !== 'With Payment Type') {
            return tableData
        } else {
            return finalTableData
        }

    }
    const getMainHeader = (columns = []) =>
        columns.map((column) => {
            const header = column.header || column.headerName || column.exportHead || ''
            return {
                ...column,
                header,
                exportHead: column.exportHead || header,
                align: column.align || column.textAlign || 'left',
                weight: column.weight ?? 80,
            }
        })

    const ensureHeaderColumnAfter = (columns = [], referenceField, newColumn) => {
        const updatedColumns = [...columns]
        const referenceIndex = updatedColumns.findIndex((column) => column.field === referenceField)

        if (referenceIndex === -1) {
            return updatedColumns
        }

        const existingIndex = updatedColumns.findIndex((column) => column.field === newColumn.field)

        if (existingIndex !== -1) {
            const [existingColumn] = updatedColumns.splice(existingIndex, 1)
            const nextReferenceIndex = updatedColumns.findIndex((column) => column.field === referenceField)
            updatedColumns.splice(nextReferenceIndex + 1, 0, existingColumn)
            return updatedColumns
        }

        updatedColumns.splice(referenceIndex + 1, 0, newColumn)
        return updatedColumns
    }

    const getReportHeaders = () => {
        const selectedHeaders =
            reportGroupByOptions?.Option === 'With Payment Type'
                ? UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
                    ? PDFHeaderColumnsWithPayType
                    : UseFormattedLRinReports === 2
                        ? PDFHeaderColumnsWithPayTypeFormattedLRNO
                        : PDFHeaderColumnsWithPayTypeForBoth
                : UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
                    ? PDFHeaderColumnsWithoughtPayType
                    : UseFormattedLRinReports === 2
                    ? PDFHeaderColumnsWithoughtPayTypeFormattedLRNO
                        : PDFHeaderColumnsWithoughtPayTypeForBoth

        const normalizedHeaders = selectedHeaders.map((column) =>
            column.field === 'ItemDetails'
                ? {
                    ...column,
                    headerName: 'Item Type',
                    exportHead: 'Item Type',
                }
                : column
        )
        const orderedHeaders = ensureHeaderColumnAfter(normalizedHeaders, 'ItemDetails', {
            headerName: 'Payment Type',
            exportHead: 'Payment Type',
            field: 'PaymentType',
            xlCol: { dataType: 'string', dataFormatter: null },
            align: 'left',
            isSortIcon: true,
        })

        return getMainHeader(orderedHeaders)
    }
    const getReportPayload = (groupedData) => {
        const mainHeader = getReportHeaders()
        const reportTitle =
            reportOptions?.optionId === 0
                ? 'Branch Stock Report (Booked - Pending Dispatch)'
                : 'Branch Stock Report (Received - Pending Delivery)'

        return {
            reportName: reportTitle,
            criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: groupedData,
            mainHeader,
            serialNokey :'Sr',
        }
    }
    const openViewReport = (reportPayload) => {
        const rid = Date.now().toString()

        if (!window.generatedReports) {
            window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }
    const getDestinationBranchOptions = (branches = []) =>
        branches.length
            ? [{ DestinationBranch: 'All Branch', DestinationBranchID: 0 }, ...branches]
            : []
    const handleClick1 = async () => {
        if (sourceCity == '' || sourceCity == ' ') {
            dispatch(updateAlertError({ show: true, msg: 'Select Source City', nextId: '' }))
        } else if (destinationBranch == '' || destinationBranch == ' ') {
            dispatch(updateAlertError({ show: true, msg: 'Select Destination Branch', nextId: '' }))
        } else if (!sourceBranch?.Branch) {
            dispatch(updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' }))
        } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
        } else {
            const body = {
                CompanyID: loginData?.intCompanyID,
                SelectedBranchID: sourceBranch?.BranchID || 0,
                DestinationCityID: destinationCity?.DestinationcityID || 0,
                DestinationBranchID: destinationBranch?.DestinationBranchID || 0,
                dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
                dtToDate: moment(toDate).format('YYYY-MM-DD'),
                Mode: reportOptions?.optionId,
                PaymentTypeID: paymentType?.typeId,
                IsOnline: reportView?.id,
            }
            setLoader(true)
            try {
                const res = await GetRequest(urls.getBranchStockTableData, body)
                setLoader(false)
                if (res?.status !== 'Success') {
                    setAlert({ show: true, msg: 'No Data Found', nextId: '' })
                    return
                }

                const tablesData = getFilteredData(res)
                const groupedData = groupTableData(tablesData)

                if (!Array.isArray(groupedData) || groupedData.length === 0) {
                   setAlert({ show: true, msg: 'No Data Found', nextId: '' })
                   return
                }

                openViewReport(getReportPayload(groupedData))
            } catch (error) {
                setLoader(false)
                setAlert({ show: true, msg: error?.message || 'Branch stock report generation failed', nextId: '' })
                return
            } 
        }
    }

    const handleClick2 = () => {
        if (sourceCity == '' || sourceCity == ' ') {
            dispatch(updateAlertError({ show: true, msg: 'Select Source City', nextId: '' }))
        } else if (!sourceBranch?.Branch) {
            dispatch(updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' }))
        } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
        } else {
            let url = urlValues.branchStockReport
            const urlData = urlValues.branchStockReportParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.SelBranchID = sourceBranch?.BranchID || 0
            urlData.DestCityID = destinationCity?.DestinationcityID || 0
            urlData.DestBranchID = destinationBranch?.DestinationBranchID || 0
            urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
            urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
            urlData.Status = 0
            urlData.isSummaryOnly = 0
            urlData.IsOnline = -1
            urlData.intAllowExportExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }
    useEffect(() => {
        if (branchStockFilterData.status === 'Success') {
            if (branchStockFilterData?.Data?.Table?.length >= 1) {
                const SourceCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ City: val.City, CityID: val.CityID }))),]
                const SourceBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ Branch: val.Branch, BranchID: val.BranchID, CityID: val.CityID, }))),]
                const DestinationCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationCity: val.DestinationCity, DestinationcityID: val.DestinationcityID, CityID: val.CityID, }))),]
                const updatedDestCity = DestinationCity.filter(val => val.DestinationcityID !== loginData.intBranchCityID)
                const DestinationBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationBranch: val.DestinationBranch, DestinationBranchID: val.DestinationBranchID, DestinationcityID: val.DestinationcityID, }))),]
                const updatedDestBranch = DestinationBranch.filter(val => val.DestinationBranchID !== loginData.intBranchID)

                setSourceCityData([...SourceCity.filter((obj) => obj.CityID === loginData.intBranchCityID)])
                setSourceCity(SourceCity.find((obj) => obj.CityID === loginData.intBranchCityID) || '')
                if (SourceBranch.length) SourceBranch.unshift({ Branch: 'All Branches', BranchID: 0, CityID: loginData.intBranchCityID })
                setSourceBranchData([...SourceBranch.filter((obj) => obj.CityID === loginData.intBranchCityID)])
                setSourceBranch(SourceBranch.find((obj) => obj.BranchID === loginData.intBranchID) || SourceBranch?.[0] || '')
                setDestinationCityData([{ DestinationCity: 'All Cities', DestinationcityID: 0 }, ...updatedDestCity])
                const destinationBranchOptions = getDestinationBranchOptions(updatedDestBranch)
                setSelDestinationBranchdata(destinationBranchOptions)
                setDestinationCity({ DestinationCity: 'All Cities', DestinationcityID: 0 })
                setSelDestinationBranch(destinationBranchOptions[0] || '')
            } else {
                setSourceCityData([])
                setSourceBranchData([])
                setDestinationCityData([])
                setSelDestinationBranchdata([])
                setSelDestinationBranch('')
            }
        }
    }, [branchStockFilterData])
    const handleReportOption = (val) => {
        if (val.optionId === 0) {
            if (branchStockFilterData?.Data?.Table?.length >= 1) {
                const SourceCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ City: val.City, CityID: val.CityID }))),]
                const SourceBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ Branch: val.Branch, BranchID: val.BranchID, CityID: val.CityID, }))),]
                const DestinationCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationCity: val.DestinationCity, DestinationcityID: val.DestinationcityID, CityID: val.CityID, }))),]
                const updatedDestCity = DestinationCity.filter(val => val.DestinationcityID !== loginData.intBranchCityID)
                const DestinationBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationBranch: val.DestinationBranch, DestinationBranchID: val.DestinationBranchID, DestinationcityID: val.DestinationcityID, }))),]
                const updatedDestBranch = DestinationBranch.filter(val => val.DestinationBranchID !== loginData.intBranchID)

                setSourceCityData([...SourceCity.filter((obj) => obj.CityID === loginData.intBranchCityID)])
                setSourceCity(SourceCity.find((obj) => obj.CityID === loginData.intBranchCityID) || '')
                if (SourceBranch.length) SourceBranch.unshift({ Branch: 'All Branches', BranchID: 0, CityID: loginData.intBranchCityID })
                setSourceBranchData([...SourceBranch.filter((obj) => obj.CityID === loginData.intBranchCityID)])
                setSourceBranch(SourceBranch.find((obj) => obj.BranchID === loginData.intBranchID) || SourceBranch?.[0] || '')
                setDestinationCityData([{ DestinationCity: 'All Cities', DestinationcityID: 0 }, ...updatedDestCity])
                setDestinationCity({ DestinationCity: 'All Cities', DestinationcityID: 0 })
                const destinationBranchOptions = getDestinationBranchOptions(updatedDestBranch)
                setSelDestinationBranchdata(destinationBranchOptions)
                setSelDestinationBranch(destinationBranchOptions[0] || '')
            }
        } else {
            if (branchStockFilterData?.Data?.Table?.length >= 1) {
                const SourceCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ City: val.City, CityID: val.CityID }))),]
                const updatedSourceCity = SourceCity?.filter((item) => item.CityID !== loginData.intBranchCityID)
                setSourceCityData([{ City: 'All Cities', CityID: 0 }, ...updatedSourceCity])
                setSourceCity({ City: 'All Cities', CityID: 0 })
                const SourceBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ Branch: val.Branch, BranchID: val.BranchID, CityID: val.CityID, }))),]
                const updatedSourceBranch = SourceBranch?.filter((item) => item.BranchID !== loginData.intBranchID)
                setSourceBranchData([{ Branch: 'All Branches', BranchID: 0 }, ...updatedSourceBranch])
                setSourceBranch({ Branch: 'All Branches', BranchID: 0 })
                const DestinationCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationCity: val.DestinationCity, DestinationcityID: val.DestinationcityID, CityID: val.CityID, }))),]
                setDestinationCityData(DestinationCity.filter((obj) => obj.DestinationcityID === loginData.intBranchCityID))
                setDestinationCity([...DestinationCity.filter((obj) => obj.DestinationcityID === loginData.intBranchCityID)]?.[0] || '')
                const DestinationBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationBranch: val.DestinationBranch, DestinationBranchID: val.DestinationBranchID, DestinationcityID: val.DestinationcityID, }))),]
                const selectedDestinationBranches = DestinationBranch.filter((obj) => obj.DestinationBranchID === loginData.intBranchID)
                setSelDestinationBranchdata(selectedDestinationBranches)
                setSelDestinationBranch(selectedDestinationBranches[0] || '')
            }
        }
    }
    const selectedSourceCity = (obj) => {
        setSourceCity(obj)
        const filterSourceBranch = branchStockFilterData?.Data?.Table?.filter((val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val.BranchID === 0)
        setSourceBranchData([{ Branch: 'All Branches', BranchID: 0 }, ...filterSourceBranch])
        setSourceBranch(filterSourceBranch?.[0])
    }
    const selectedDestCity = (obj) => {
        setDestinationCity(obj)
        const filterDestBranch = branchStockFilterData?.Data?.Table?.filter((val) => val.DestinationcityID === obj?.DestinationcityID || obj?.DestinationcityID === 0 || val.DestinationBranchID === 0) || []
        const destinationBranchOptions = getDestinationBranchOptions(filterDestBranch)
        setSelDestinationBranchdata(destinationBranchOptions)
        setSelDestinationBranch(destinationBranchOptions[0] || '')
    }
    const paymentDropdownData = (GoodBalReprtPayType?.filter((val) => roleRights?.Table?.filter((item) => item.BookingRightsID === 1)?.[0][val.uniqKey] === 1 || val.uniqKey == 'All')).map((item) => {
        if (UseToPayAsCOD === 1) {
            switch (item.typeId) {
                case 2:
                    return { ...item, name: "COD" };
                case 7:
                    return { ...item, name: "COD Manual" };
                case 9:
                    return { ...item, name: "COD DDDV" };
                case 4:
                    return null;
                default:
                    return item;
            }
        }
        return item;
    })
        .filter(Boolean);
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                <ReportHeading reportName={reportName} />
                <Box sx={sx.reportFlex}>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={id.selectCompnay}
                            label={lb.select_company}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            // onSelect={(val) => { setSelCompany(val); setShowTable(false) }}
                            width="100%"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            disabled={true}
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            id={id.goButton}
                            className="btn btn-primary"
                        >
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsxGrow} style={{ width: '120px' }} className="input--container bookingDatePicker">
                        <Datepicker
                            name={'from_collection_date'}
                            value={fromDate}
                            label={'From Date'}
                            id={id.fromDate}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt(id.toDate)
                            }}
                            width="100%"
                            dateDiff={730}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow} style={{ width: '120px' }} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Date'}
                            value={toDate}
                            id={id.toDate}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt('goodGoBtn')
                            }}
                            width="100%"
                            dateDiff={730}
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            id="goodGoBtn"
                            onKeyDown={(e) => navigation3(e, 'sourceBranch', id.toDate, () => filterData())}
                            variant="contained"
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                            onClick={filterData}
                        >
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsx} style={{ width: '235px' }}>
                        <DropDownOA
                            id={id.anReportOptions}
                            data={reportOption || []}
                            defaultvalue={reportOptions?.Option || ''}
                            width="100%"
                            searchPlaceholder={`Search By Report Options`}
                            label={'Report Options'}
                            tabIndex="2"
                            dataKey={`Option`}
                            idKey={`optionId`}
                            listWidth="200px"
                            onSelect={(value) => {
                                handleReportOption(value)
                                setReportOptions(value)
                            }}
                            nextId={id.anReportGroupByOptions}
                            prevId={id.gbView}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            label="Source City"
                            id="sourceCity"
                            nextId={'destinationBranch'}
                            prevId={'sourceBranch'}
                            defaultvalue={sourceCity?.City || ''}
                            data={removeDuplicatesFromArray(sourceCityData, 'CityID')}
                            dataKey={`City`}
                            idKey={`CityID`}
                            onSelect={(obj) => selectedSourceCity(obj)}
                            width="225px"
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            label="Source Branch"
                            id="sourceBranch"
                            nextId={'destinationCity'}
                            prevId={'goodGoBtn'}
                            disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                            // data={removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID') || []}
                            data={removeDuplicatesFromArray(sourceBranchData, 'BranchID') || []}
                            defaultvalue={sourceBranch?.Branch || ""}
                            dataKey={`Branch`}
                            idKey={`BranchID`}
                            onSelect={(val) => { setSourceBranch(val) }}
                            width="225px"
                            listWidth={'250px'}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            label="Destination City"
                            id="destinationCity"
                            nextId={'destinationBranch'}
                            prevId={'sourceBranch'}
                            defaultvalue={destinationCity?.DestinationCity || destinationCity}
                            data={removeDuplicatesFromArray(destinationCityData, 'DestinationcityID') || []}
                            dataKey={`DestinationCity`}
                            idKey={`DestinationcityID`}
                            onSelect={(obj) => selectedDestCity(obj)}
                            width="225px"
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            key={`destinationBranch-${destinationBranch?.DestinationBranch || 'empty'}-${destinationBranchdata.length}`}
                            label="Destination Branch"
                            id="destinationBranch"
                            nextId={id.gbPaymentType}
                            prevId={'destinationCity'}
                            defaultvalue={destinationBranch?.DestinationBranch || destinationBranch}
                            data={removeDuplicatesFromArray(destinationBranchdata, 'DestinationBranchID') || []}
                            dataKey={`DestinationBranch`}
                            idKey={`DestinationBranchID`}
                            onSelect={(obj) => { setSelDestinationBranch(obj) }}
                            width="225px"
                            listWidth={'250px'}
                        />
                    </Item>
                    <Item sx={sx.itemsx} style={{ width: '205px' }}>
                        <DropDownOA
                            id={id.gbPaymentType}
                            data={paymentDropdownData || []}
                            defaultvalue={paymentType?.name}
                            width="100%"
                            searchPlaceholder={`Search By Payment Type`}
                            label={'Payment Type'}
                            tabIndex="2"
                            dataKey={`name`}
                            idKey={`typeId`}
                            onSelect={(value) => {
                                setPaymentType(value)
                            }}
                            nextId={id.gbView}
                            prevId={'destinationBranch'}
                        />
                    </Item>
                    <Item sx={sx.itemsx} style={{ width: '205px' }}>
                        <DropDownOA
                            id={id.gbView}
                            defaultvalue={reportView?.view}
                            data={branchStockReportViewData}
                            width="100%"
                            searchPlaceholder={`Search By View`}
                            label={'Report View'}
                            tabIndex="2"
                            dataKey={`view`}
                            idKey={`id`}
                            onSelect={(value) => setReportView(value)}
                            nextId={id.anReportOptions}
                            prevId={id.gbPaymentType}
                        />
                    </Item>
                    <Item sx={sx.itemsx} style={{ width: '235px' }}>
                        <DropDownOA
                            id={id.anReportGroupByOptions}
                            data={reportGroupByOption || []}
                            defaultvalue={reportGroupByOptions?.Option || ''}
                            width="100%"
                            searchPlaceholder={`Search By Report Group By`}
                            label={'Report Group By'}
                            tabIndex="2"
                            dataKey={`Option`}
                            idKey={`optionId`}
                            listWidth="200px"
                            onSelect={(value) => {
                                setReportGroupByOptions(value)
                            }}
                            nextId={id.reportmainButton}
                            prevId={id.anReportOptions}
                        />
                    </Item>
                    <Item
                        sx={sx.itemsx}
                        style={{ cursor: 'pointer' }}
                        onKeyDown={(e) =>
                            navigation3(e, id.fromDate, id.anReportGroupByOptions, () => handleClick1())}
                    >
                        <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            id1={id.reportmainButton}
                            prevID={id.summaryCheck}
                            onClick1={handleClick1}
                            onClick2={handleClick2}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
                        <RefreshSvg width={'24px'} height={'24px'} />
                    </Item>
                </Box>
            </Item>
        </>
    )
}

export default BranchStockReportNew
